import { render, staticRenderFns } from "./Carrosell.vue?vue&type=template&id=d18261f0"
import script from "./Carrosell.vue?vue&type=script&lang=js"
export * from "./Carrosell.vue?vue&type=script&lang=js"
import style0 from "./Carrosell.vue?vue&type=style&index=0&id=d18261f0&prod&lang=css"


/* normalize component */
import normalizer from "!../corporativo/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports